import React from 'react';
import { jsPDF } from 'jspdf';

function formatCurrency(value) {
  return `${Number(value || 0).toLocaleString('vi-VN')} ₫`;
}

function paymentMethodLabel(method) {
  return method === 'debt' ? 'Công nợ' : 'Thanh toán ngay';
}

function paymentStatusLabel(status) {
  if (status === 'paid') {
    return 'Đã thu';
  }

  if (status === 'partial') {
    return 'Thu một phần';
  }

  return 'Chưa thu';
}

function OrderDetailModal({ order, onClose }) {
  if (!order) {
    return null;
  }

  const exportPdf = () => {
    const doc = new jsPDF({ unit: 'pt', format: 'a4' });
    const margin = 40;
    let y = margin;

    doc.setFontSize(16);
    doc.text('HÓA ĐƠN BÁN HÀNG', margin, y);
    y += 28;

    doc.setFontSize(12);
    doc.text(`Mã hóa đơn: ${order.id}`, margin, y);
    y += 18;
    doc.text(`Khách hàng: ${order.customer_name}`, margin, y);
    y += 18;
    doc.text(`Loại: ${order.order_type === 'wholesale' ? 'Bán sỉ' : 'Bán lẻ'}`, margin, y);
    y += 18;
    doc.text(`Hình thức thanh toán: ${paymentMethodLabel(order.payment_method)}`, margin, y);
    y += 18;
    doc.text(`Trạng thái thu: ${paymentStatusLabel(order.payment_status)}`, margin, y);
    y += 18;
    doc.text(`Ngày: ${new Date(order.created_at).toLocaleDateString('vi-VN')}`, margin, y);
    y += 26;

    doc.setFontSize(12);
    doc.text('Sản phẩm', margin, y);
    doc.text('SL', margin + 220, y);
    doc.text('Đơn giá', margin + 300, y);
    doc.text('Thành tiền', margin + 410, y);
    y += 18;

    order.details.forEach((item) => {
      doc.text(item.name, margin, y);
      doc.text(item.quantity.toString(), margin + 220, y);
      doc.text(formatCurrency(item.unit_price), margin + 300, y);
      doc.text(formatCurrency(item.total_price), margin + 410, y);
      y += 18;
      if (y > 740) {
        doc.addPage();
        y = margin;
      }
    });

    y += 20;
    doc.setFontSize(12);
    doc.text(`Tổng tiền: ${formatCurrency(order.total_amount)}`, margin, y);
    y += 18;
    doc.text(`Đã thu: ${formatCurrency(order.amount_paid)}`, margin, y);
    y += 18;
    doc.text(`Còn nợ: ${formatCurrency(order.debt_amount)}`, margin, y);
    doc.save(`HoaDon-${order.id}.pdf`);
  };

  return (
    <div className="modal show">
      <div className="modal-content" style={{ maxWidth: '700px' }}>
        <div className="modal-header">
          <h3 className="modal-title">Chi tiết hóa đơn #{order.id}</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Khách hàng</label>
            <div>{order.customer_name}</div>
          </div>
          <div className="form-group">
            <label>Loại đơn</label>
            <div>{order.order_type === 'wholesale' ? 'Bán sỉ' : 'Bán lẻ'}</div>
          </div>
          <div className="form-group">
            <label>Hình thức thanh toán</label>
            <div>{paymentMethodLabel(order.payment_method)}</div>
          </div>
          <div className="form-group">
            <label>Trạng thái thu</label>
            <div>{paymentStatusLabel(order.payment_status)}</div>
          </div>
          <div className="form-group">
            <label>Ngày</label>
            <div>{new Date(order.created_at).toLocaleDateString('vi-VN')}</div>
          </div>

          <div className="card" style={{ marginTop: '20px' }}>
            <table>
              <thead>
                <tr>
                  <th>Sản phẩm</th>
                  <th>Số lượng</th>
                  <th>Đơn giá</th>
                  <th>Thành tiền</th>
                </tr>
              </thead>
              <tbody>
                {order.details.map((item) => (
                  <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>{item.quantity}</td>
                    <td>{formatCurrency(item.unit_price)}</td>
                    <td>{formatCurrency(item.total_price)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', gap: '20px', alignItems: 'flex-start' }}>
            <div>
              <strong>Tổng thanh toán: {formatCurrency(order.total_amount)}</strong>
              <div style={{ marginTop: '8px' }}>Đã thu: <strong>{formatCurrency(order.amount_paid)}</strong></div>
              <div style={{ marginTop: '6px', color: Number(order.debt_amount || 0) > 0 ? '#dc3545' : '#218838' }}>
                Còn nợ: <strong>{formatCurrency(order.debt_amount)}</strong>
              </div>
            </div>
            <div>
              <button className="success" onClick={() => window.print()}>In hóa đơn</button>
              <button style={{ marginLeft: '10px' }} onClick={exportPdf}>Xuất PDF</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderDetailModal;
